import { UnixTimestamp } from "@cervval.js/common/src/tools/timestamps.tools";
import { BOOLEAN, ID, NUMBER, SHORT_STRING, STRING } from "../propertyTypes/property.types";

export enum GENDER {
    FEMALE = 1,
    MALE = 2
}

/**
 * Numerical enum for the days of the week, ranging from 1 (Monday) to 7 (Sunday)
 */
export enum DAYS_OF_WEEK {
    MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6,
    SUNDAY = 7,
}

export type UserFieldTypes = {
    "ID": ID,
    "SHORT_TEXT": SHORT_STRING,
    "TEXT": STRING,
    "UnixTimestamp": UnixTimestamp,
    "BOOLEAN": BOOLEAN,
    "NUMBER": NUMBER // catch-all type when lazy to declare numerical enum
}

export type UserFieldTypeName = keyof UserFieldTypes;